module.exports = __webpack_public_path__ + "img/fil_selected.dc58e0a0.svg";